<template>
  <div
    class="criterion-card main__light_green my-5"
    :class="{ 'not_selected ': !is_selected && blur_unselected,' secondary__green_chosen criterion-card_opened': opened }"
    data-qa="criterion-card"
    :ripple="false"
    @click="open">
    <div
      class="criterion-card__content">
      <div>
        <div
          class="criterion-card__title"
          data-qa="criterion-card-title">
          {{ item.name }}
        </div>
        <div>
          <KeyValue
            v-if="item.criteriaNames && item.criteriaNames.length"
            :caption="$t('Tenders.AddedCriteria')"
            data-qa="criterion-card-criteriaNames"
            :value="item.criteriaNames.join(', ')"/>
          <KeyValue
            v-if="item.useReducedPrice"
            :caption="$t('Tenders.GivenPrice')"
            data-qa="criterion-card-formula">
            <ReducedPriceFormula :card="item"/>
          </KeyValue>
          <div class="flex flex-between gap-2 text-left">
            <div style="width: 58%">
              <span class="h7-text-medium">
                {{ bigFirstLetter( $t('Tenders.Categories')) }}:
              </span>
              <span class="criterion-card__category h7-text black--text">
                {{ item.category ? item.category : $t('Purchasing.All') }}
              </span>
            </div>
            <div style="width: 41%">
              <span class="h7-text-medium">
                {{ $t('Tenders.TypesOfTenders') }}:
              </span>
              <span class="criterion-card__biddingType h7-text black--text">
                {{ item.biddingType ? item.biddingType : $t('Purchasing.All') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="criterion-card__content-right">
        <sAlert
          v-if="item.criterionCardType != 'TEMPLATE'"
          width="230px">
          <template slot="desc">
            {{ $t(`Tenders.${item.criterionCardType}Card`) }}
          </template>
        </sAlert>
        <CriteriaTemplateMenu
          v-else
          :card="item"
          data-qa="criterion-card-menu"
          :tender="tender"
          @deleteCard="deleteCard"
          @updateCard="$emit('updateCard')"/>
        <sButton
          v-if="!locked"
          class="h11-links"
          data-qa="criterion-card-select-btn"
          type="border"
          @click.stop="addToSelected">
          {{ is_selected ? $t('Tenders.EditCriteria') : $t('Tenders.SelectCriteriaCard') }}
        </sButton>
      </div>
    </div>
    <transition
      name="s-zoom-in-top">
      <div v-show="opened">
        <sDivider/>
        <sIcon
          v-if="loading"
          class="my-5"
          color="var(--white-color)"
          size="30"
          spin
          type="loading"/>
        <CriteriaTable
          v-else
          :bidding_type="bidding_type"
          :card="details"
          class=" secondary__green_chosen"
          :items="details.criterias"/>
      </div>
    </transition>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import CriteriaTable from 'components/tenders/critetia/CriteriaTable.vue'
import ReducedPriceFormula from 'components/tenders/critetia/ReducedPriceFormula.vue'
import CriteriaTemplateMenu from 'components/tenders/critetia/CriteriaTemplateMenu.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'criterionCard',
  mixins: [modalMixin],
  data() {
    return {
      opened: false,
      details: {},
      loading: false
    }
  },
  props: {
    item: Object,
    is_selected: Boolean,
    openEditing: Function,
    blur_unselected: Boolean,
    bidding_type: Object,
    locked: Boolean,
    tender: {
      type: Object
    }
  },
  methods: {
    async open() {
      this.loading = true
      this.opened = !this.opened
      if ( !this.details.id ) {
        this.details = await this.$store.dispatch('infoAboutCriterionCard', this.item.code)
      }
      this.loading = false
    },
    async addToSelected() {
      await this.openEditing(this.item.code)
    },
    deleteCard(templateId) {
      this.$emit('deleteCard', templateId )
    }
  },
  components: {
    KeyValue,
    CriteriaTable,
    ReducedPriceFormula,
    CriteriaTemplateMenu
  }
}
</script>
<style lang="scss" scoped>
.criterion-card {
  transition: 0.3s;
  cursor: pointer;
  &__content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
    padding: 30px;
    &-right {
      display: grid;
      align-content: space-between;
      justify-items: end;
      gap: 8px;
    }
  }
  &__title {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    text-align: left;
  }
  &.criterion-card_opened {
    .criterion-card__category, .criterion-card__criteria-names, .criterion-card__biddingType {
      white-space: normal !important;
    }
  }
}
.not_selected {
  opacity: 0.7;
}
</style>
